import { render, staticRenderFns } from "./ProductReturnRow.vue?vue&type=template&id=4581f649&"
import script from "./ProductReturnRow.vue?vue&type=script&lang=js&"
export * from "./ProductReturnRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports